/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {GrupoAcesso} from '../../models/grupo_acesso'
import {BaseDescSCH, BaseSCH, getBaseSCH} from "../../search/BaseSCH";
import {getGrupoAcessoSCH, GrupoAcessoSCH} from "../../search/GrupoAcessoSCH";

const url = '/grupo_acesso'

const state = {
  all: [],
  allList: [],
  grupo_acesso: new GrupoAcesso(),
  filtro: new Filtro()
}

const getters = {
  listaAllGrupoAcessos: (state) => {
    return state.allList
  },

  listaGrupoAcessos: (state) => {
    return state.all
  },
  pegaGrupoAcesso: (state) => {
    return state.grupo_acesso
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['descricao'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {id, onSucesso,onErro}) {
    try {
      var filtro = getGrupoAcessoSCH('grupo_acesso_id', id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_GRUPO_ACESSO', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', GrupoAcessoSCH(perPage))
  },

  async setAllListGrupoAcessos({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
    },
  async setAllGrupoAcessos({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_GRUPO_ACESSOS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarGrupoAcesso({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.grupo_acesso, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setGrupoAcesso({commit}, grupo_acesso) {
    commit('SET_GRUPO_ACESSO', grupo_acesso)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_GRUPO_ACESSOS(state, grupo_acessos) {
    state.all = grupo_acessos
  },
  SET_GRUPO_ACESSO(state, grupo_acesso) {
    state.grupo_acesso = grupo_acesso
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
